import './popup.css';
import Cookie from '../core/helperFunctions/Cookie';

const popup = () => {
 
    $(document).ready(function () {
    var d = new Date();
    var data = d.getDate() + '/' + d.getMonth() + '/' + d.getFullYear() + ' ' + d.getHours() + ':' + d.getMinutes();
    var days = $('.mass-popup').data('cookie');
    var id = $('.mass-popup').data('id');

    // if (Cookie.getCookie('hidePopup_'+id) === '1') {
    if (Cookie.getCookie('hidePopup_'+id) === '1') {
            $('#mass-popup').hide();
     } else {
         $('#mass-popup').show();
         $('.mass-popup').fadeIn(500);
         $(".btn-close").click(function () {
            Cookie.setCookie('hidePopup_'+id, 1, days);
             $('#mass-popup').hide();
         });
         $(".setCookieTime").click(function () {
            Cookie.setCookie('hidePopup_'+id, 1, days);
             $('#mass-popup').hide();
         });
    }
});
}

export { popup }


// WEBPACK FOOTER //
// ../components/popup/popup.js